import React from 'react';
import DTBList from 'views/App/Portal/DTB/Library/List';
import { DTB, DTBPackageItem } from 'views/App/Portal/DTB/_types/dtb';

interface AvailableDtbsTabProps {
  selectedDtbs: DTB[];
  setSelectedDtbs: React.Dispatch<React.SetStateAction<DTB[]>>;
  onContinue: () => void;
  continueDisabled: boolean;
  manualId?: string;
  existingPackageDtbs?: DTBPackageItem[];
}

const AvailableDtbsTab: React.FC<AvailableDtbsTabProps> = ({
  selectedDtbs,
  setSelectedDtbs,
  onContinue,
  continueDisabled,
  manualId,
  existingPackageDtbs = [],
}) => {
  const existingDtbIds = existingPackageDtbs.map((dtb) => dtb.id);

  return (
    <>
      <DTBList
        selectionMode
        selectedDtbs={selectedDtbs}
        setSelectedDtbs={setSelectedDtbs}
        continueDisabled={continueDisabled}
        onContinue={onContinue}
        embedded
        manualId={manualId}
        excludeIds={existingDtbIds}
        preserveExternalSelection={true}
        allowLockedSelection={true}
      />
    </>
  );
};

export default AvailableDtbsTab;
